<div *ngIf="active">
  <div *ngIf="(moduleList$ | async) as moduleList; else loadingTemplate">
    <div class="form-group" *ngIf="moduleList.length > 0; else noDataTemplate">
      <label [hidden]="hideLabel" for="SelectModule">Module</label>
      <ng-select required [items]="moduleList" bindLabel="Name" [multiple]="false" [hideSelected]="true"
                 [loading]="moduleListLoading" [typeahead]="moduleListinput$" [(ngModel)]="selectedModule"
                 name="SelectModule"
                 placeholder="{{selectModuleText}}" (change)=selectedModuleChanged($event)>
      </ng-select>
    </div>
    <ng-template #noDataTemplate>
      There are no modules avaliable yet. Please create a valid module first.
    </ng-template>
  </div>
  <ng-template #loadingTemplate>
    There are no modules avaliable yet. Please create a valid module first.
  </ng-template>
</div>
